import _get from "lodash/get";
import { LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_30 } from '@nerdwallet/home-constants';
import { CREDIT_SCORE_BAND_EXCELLENT, CREDIT_SCORE_BAND_FAIR, CREDIT_SCORE_BAND_GOOD, CREDIT_SCORE_BREAKPOINT_FAIR, CREDIT_SCORE_BREAKPOINT_GOOD, LTV_80_85_INDEX, LTV_85_90_BREAKPOINT, LTV_85_90_INDEX, LTV_90_95_BREAKPOINT, LTV_90_95_INDEX, LTV_95_97_BREAKPOINT, LTV_95_97_INDEX, PMI_TABLE } from '../data/pmi';
export var getCreditScoreBand = function getCreditScoreBand(creditScore) {
  if (creditScore < CREDIT_SCORE_BREAKPOINT_FAIR) {
    return CREDIT_SCORE_BAND_FAIR;
  }

  if (creditScore < CREDIT_SCORE_BREAKPOINT_GOOD) {
    return CREDIT_SCORE_BAND_GOOD;
  }

  return CREDIT_SCORE_BAND_EXCELLENT;
};
export var getLtvIndex = function getLtvIndex(ltv) {
  if (ltv > LTV_95_97_BREAKPOINT) {
    return LTV_95_97_INDEX;
  }

  if (ltv > LTV_90_95_BREAKPOINT) {
    return LTV_90_95_INDEX;
  }

  if (ltv > LTV_85_90_BREAKPOINT) {
    return LTV_85_90_INDEX;
  }

  return LTV_80_85_INDEX;
};

var getLoanProgram = function getLoanProgram(loanProgram) {
  return loanProgram === LOAN_PROGRAM_FIXED_15 || loanProgram === LOAN_PROGRAM_FIXED_30 ? loanProgram : LOAN_PROGRAM_FIXED_30;
};

export default (function (_ref) {
  var creditScore = _ref.creditScore,
      loanAmount = _ref.loanAmount,
      loanProgram = _ref.loanProgram,
      purchasePrice = _ref.purchasePrice;
  return _get(PMI_TABLE, [getLoanProgram(loanProgram), getCreditScoreBand(creditScore), getLtvIndex(loanAmount / purchasePrice)]) * loanAmount;
});